"use client";
import { useEffect, useState, useCallback } from "react";
import { usePathname } from "next/navigation";

export default function ScrollToTop() {
  const pathname = usePathname();
  const [isVisible, setIsVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Wait until mounted on client to avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  // Smooth scroll function (memoized)
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (!mounted) return;
    
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setIsVisible(window.scrollY > 300);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [mounted]);

  // Reset scroll on route change
  useEffect(() => {
    if (!mounted) return;
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, mounted]);

  // Always render the same structure to avoid hydration mismatch
  // Use CSS to hide/show instead of conditional rendering
  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`fixed bottom-8 right-8 z-[999] flex h-10 w-10 items-center justify-center rounded-md bg-primary text-white shadow-md transition duration-300 hover:bg-dark ${
        mounted && isVisible ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
      }`}
    >
      <span className="mt-[6px] h-3 w-3 rotate-45 border-l border-t border-white" />
    </button>
  );
}

